const POST_AUTH_REDIRECT_KEY = "post_auth_redirect_path";

interface LocationLike {
  pathname?: string;
  search?: string;
  hash?: string;
}

function isSafeInternalPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

function getPathname(path: string): string {
  return path.split(/[?#]/, 1)[0] || "/";
}

function shouldPersistRedirect(path: string): boolean {
  if (!isSafeInternalPath(path)) {
    return false;
  }

  const pathname = getPathname(path);

  return ![
    "/landing",
    "/login",
    "/signup",
    "/forget-email",
    "/login/2FA-auth",
  ].some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function buildRedirectPath(
  location: LocationLike | null | undefined
): string | null {
  if (!location?.pathname) {
    return null;
  }

  const redirectPath = `${location.pathname}${location.search || ""}${location.hash || ""}`;
  return shouldPersistRedirect(redirectPath) ? redirectPath : null;
}

export function persistPostAuthRedirect(
  location: LocationLike | null | undefined
): void {
  const redirectPath = buildRedirectPath(location);

  if (!redirectPath) {
    return;
  }

  localStorage.setItem(POST_AUTH_REDIRECT_KEY, redirectPath);
}

export function consumePostAuthRedirect(fallbackPath = "/"): string {
  const storedRedirect = localStorage.getItem(POST_AUTH_REDIRECT_KEY) || "";
  localStorage.removeItem(POST_AUTH_REDIRECT_KEY);

  if (storedRedirect && shouldPersistRedirect(storedRedirect)) {
    return storedRedirect;
  }

  return fallbackPath;
}
